module.exports = __webpack_public_path__ + "static/media/signin.4ad3f9f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/signin.png
// module id = 233
// module chunks = 0